
document.addEventListener('DOMContentLoaded', function () {
    const accordionHeaders = document.querySelectorAll('.eael-accordion-header');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', function () {
            const content = this.nextElementSibling;

            // Toggle active class for the header
            this.classList.toggle('active');
            
            // Toggle content visibility
            if (content.style.display === 'block') {
                content.style.display = 'none';
                this.querySelector('.fa-plus').style.display = 'inline-block';
                this.querySelector('.fa-minus').style.display = 'none';
            } else {
                content.style.display = 'block';
                this.querySelector('.fa-plus').style.display = 'none';
                this.querySelector('.fa-minus').style.display = 'inline-block';
            }
        });
    });
});